import {API_URL} from './constants/config';

class Api {
    static getLanguages() {
        return [
            {
                slug: "en",
                title: "Anglais",
                native: "English",
                flag: "https://cdn4.iconfinder.com/data/icons/flat-circle-flag/182/united_kingdom_UK_England_circle_flag-512.png"
            }
        ];
    }
    static getCategories() {
        return [
            {
                title: "Cleaning",
                name: "a cleaner",
                label: "What are the symptoms?",
                slug: "cleaning",
                description: "To select your ideal cleaner start here",
            },
            {
                title: "Sealing",
                name: "a sealer",
                label: "Choose the finish you’d like",
                slug: "sealing",
                description: "To select your ideal sealer start here",
            },
            {
                title: "Aftercare",
                name: "aftercare",
                label: "Which finish did you use?",
                slug: "aftercare",
                description: "To select your aftercare cleaner start here",
            },
            {
                title: "Tooling Up",
                name: "tools",
                label: "Choose the tools to use",
                slug: "tools",
                description: "To select your required tools start here",
            },
        ];
    }
    static getSurfaces() {
        return fetch(`${API_URL}floors`).then(response => {
            return response.json();
        }).catch(error => {
            return error;
        });
    }
    static getOptions() {
        return fetch(`${API_URL}options`).then(response => {
            return response.json();
        }).catch(error => {
            return error;
        });
    }
    static getMatches() {
        return fetch(`${API_URL}matches`).then(response => {
            return response.json();
        }).catch(error => {
            return error;
        });
    }
    static getProducts() {
        return fetch(`${API_URL}products`).then(response => {
            return response.json();
        }).catch(error => {
            return error;
        });
    }
    static sendChoicesEmail(data, callback) {
        return fetch(`${API_URL}send_choices_email`, { method: 'post', body: JSON.stringify(data) }).then(response => {
            callback(response);
            return response.json();
        }).catch(error => {
            return error;
        });
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api.js